import { render, staticRenderFns } from "./CustomFlowyNode.vue?vue&type=template&id=41a3a3ea&scoped=true"
import script from "./CustomFlowyNode.vue?vue&type=script&lang=js"
export * from "./CustomFlowyNode.vue?vue&type=script&lang=js"
import style0 from "./CustomFlowyNode.vue?vue&type=style&index=0&id=41a3a3ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a3a3ea",
  null
  
)

export default component.exports